import { restDelete, restGet, restPost, restPut } from "apiCommandsExecutor/rest";

import { CouponDto, CouponsPageDto, CouponTypeDto } from "./restModels";
import { CouponRequestDto, CreateCouponRequestDto } from "./restRequests";

// Промокоды меню (REST /api/rest/warehouse/v1). Заведение бэк берёт из аккаунта,
// меню — из параметра; выборка отсортирована от новых промокодов к старым.
export const getCoupons = (
    menuId: number,
    type: CouponTypeDto | null,
    skip: number,
    limit: number
) =>
    restGet<CouponsPageDto>("/coupons", {
        menuId,
        skip,
        limit,
        ...(type ? { type } : {}),
    });

export const createCoupon = (body: CreateCouponRequestDto) =>
    restPost<CouponDto>("/coupons", body);

export const updateCoupon = (couponId: number, body: CouponRequestDto) =>
    restPut<CouponDto>(`/coupons/${couponId}`, body);

export const deleteCoupon = (couponId: number) =>
    restDelete<CouponDto>(`/coupons/${couponId}`);
